import { Directive, Input, HostBinding } from '@angular/core';

@Directive({
  selector: '[appDefault]',
  host: {
    '(error)': 'updateUrl()',
    '(load)': 'load()',
    '[src]': 'src',
  },
})
export class PreLoadDirective {
  @Input()
  watchLoad: boolean;

  @Input()
  src: string;

  @Input()
  appDefault: string;

  @HostBinding('class.loaded')
  isLoaded = false;

  updateUrl() {
    this.src = this.appDefault;
  }

  load() {
    if (this.watchLoad) {
      this.isLoaded = true;
    }
  }
}
